import useId from '_core/hooks/useId';

export default useId;
